import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import numeral from 'numeral';
import { IoArrowForwardCircleOutline, IoCloseCircle, IoCloudDownloadSharp } from 'react-icons/io5';
import Image from 'src/components/image';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

function useOnClickOutsideBox(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

const SliderFull = ({
  data,
  heading = null,
  dataSrc,
  type,
  more,
  settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    centerMode: true,
    centerPadding: '5px',
    className: 'center',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '60px'
        }
      },
      {
        breakpoint: 475,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  },
  eventDataLayer,
  headingDatalayer
}) => {
  const boxRef = useRef();
  const [toggle, setToggle] = useState({
    key: null,
    status: false,
    type: null
  });

  function renderSlideItems() {
    if (data.length > 0) {
      if (type === 'newspaper') {
        const num = new Date().getDay() === 1 ? 28 : 24;
        const cloneData = [...data].slice(1, num);
        // console.log('newspaper', { cloneData });
        return (
          <Slider {...settings} style={{ display: 'block', padding: 10 }} aria-hidden='true'>
            <div
              className='slider-card'
              onClick={() => {
                setToggle({ key: 0, status: true, type: type });
                //! DATALAYER
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    ...eventDataLayer?.data,
                    title: `${more}${dataSrc}${numeral(1).format('00')}.jpg`,
                    carousel: 1
                  }
                });
              }}
            >
              <Image image={`${dataSrc}${numeral(1).format('00')}.jpg`} title={heading} small={true} type='CARD_MEDIUM' />
            </div>
            {cloneData.map((item, index) => (
              <div key={index} className='slider-card'>
                <a
                  href={more}
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                  //! DATALAYER
                  onClick={() =>
                    sendDataLayerGlobal({
                      ...eventDataLayer,
                      data: {
                        ...eventDataLayer?.data,
                        title: `${more}${dataSrc}${numeral(index + 2).format('00')}.jpg`,
                        carousel: index + 2
                      }
                    })
                  }
                >
                  <Image image={`${dataSrc}${numeral(index + 2).format('00')}.jpg`} title={heading} type='CARD_MEDIUM' />
                </a>
              </div>
            ))}
          </Slider>
        );
      } else if (type === 'events') {
        return (
          <Slider {...settings} style={{ display: 'block', padding: 10 }} aria-hidden='true'>
            {data.map((item, index) => (
              <div key={index} className='slider-card'>
                <a
                  href={parsePath(more, index + 1)}
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                  //! DATALAYER
                  onClick={() =>
                    sendDataLayerGlobal({
                      ...eventDataLayer,
                      data: {
                        ...eventDataLayer?.data,
                        title: parsePath(more, index + 1),
                        carousel: index + 1
                      }
                    })
                  }
                >
                  <Image image={`${dataSrc}${numeral(index + 1).format('00')}.jpg`} title={heading} type='CARD_MEDIUM' />
                </a>
              </div>
            ))}
          </Slider>
        );
      } else {
        return (
          <Slider {...settings} style={{ display: 'block', padding: 10 }} aria-hidden='true'>
            {data.map((item, index) => (
              <div
                key={index}
                className='slider-card'
                //! DATALAYER
                onClick={() => {
                  setToggle({ key: index, status: true, type: type });
                  sendDataLayerGlobal({
                    ...eventDataLayer,
                    data: {
                      ...eventDataLayer?.data,
                      carousel: index + 1
                    }
                  });
                }}
              >
                <Image image={`${dataSrc}${numeral(index + 1).format('00')}.jpg`} title={heading} small={true} type='CARD_MEDIUM' />
              </div>
            ))}
          </Slider>
        );
      }
    }
  }

  function parsePath(data, key) {
    if (data.length > 0) {
      const path = data.filter(item => item.id === key);
      return path[0].link;
    } else {
      return data;
    }
  }

  useOnClickOutsideBox(boxRef, async () => {
    await setToggle({ status: false, key: null, type: null });
  });

  return (
    <>
      {heading !== null && (
        <div className='slider-heading'>
          <h3>{heading}</h3>
        </div>
      )}
      <div className='slider-item'>{renderSlideItems()}</div>
      {toggle.status && toggle.type !== null && (
        <div className='popup-box'>
          <div className='image-box' ref={boxRef}>
            <div className='action-box'>
              <a
                className='btn-download'
                href={more}
                target='_blank'
                rel='noopener noreferrer nofollow'
                download={type === 'stock'}
                //! DATALAYER
                onClick={() =>
                  sendDataLayerGlobal({
                    ...eventDataLayer,
                    data: {
                      ...eventDataLayer?.data,
                      title: type === 'stock' ? `ดาวน์โหลด-${more}` : 'เพิ่มเติม',
                      index: 1
                    }
                  })
                }
              >
                {type === 'stock' ? (
                  <>
                    ดาวน์โหลด <IoCloudDownloadSharp />
                  </>
                ) : (
                  <>
                    เพิ่มเติม <IoArrowForwardCircleOutline />
                  </>
                )}
              </a>
              <button className='btn-close' onClick={() => setToggle({ key: null, status: false, type: null })}>
                <IoCloseCircle color='red' />
              </button>
            </div>
            <Image image={`${dataSrc}${numeral(toggle.key + 1).format('00')}.jpg`} title={heading} type='FEATURE_IMAGE' />
          </div>
        </div>
      )}
    </>
  );
};

export default SliderFull;
